import { standardQuerySerializer } from '../../../api/serializers';
import { applyQueryConfig, makeCancelable, ServiceHandler } from '../../../utils';
import { licenseServiceMappings } from './license.services.mappings';

const licenseParamsSerializer = (params: any) =>
  standardQuerySerializer(applyQueryConfig(licenseServiceMappings, params));

const getAgencyLicensesHandler = makeCancelable(
  ServiceHandler({
    url: '/api/agency/v1/license/search',
    paramsSerializer: licenseParamsSerializer,
  })
);
export const getAgencyLicenses = (params: Record<string, unknown> = {}) =>
  getAgencyLicensesHandler({ params });

const getAdminAgentLicensesHandler = makeCancelable(
  ServiceHandler({
    url: '/api/agency/v1/agent/license/searchall',
    paramsSerializer: licenseParamsSerializer,
  })
);
export const getAdminAgentLicenses = (params: Record<string, unknown> = {}) =>
  getAdminAgentLicensesHandler({ params });

const getAgentSurplusLineLicensesHandler = makeCancelable(
  ServiceHandler({
    url: '/api/account/v1/agency/surplus/search',
    paramsSerializer: licenseParamsSerializer,
  })
);
export const getAgentSurplusLineLicenses = (
  params: Record<string, unknown> = {}
) => getAgentSurplusLineLicensesHandler({ params });

const getCowbellAgentSurplusLineLicensesHandler = makeCancelable(
  ServiceHandler({
    url: '/api/account/v1/agency/cowbell/surplus/search',
    paramsSerializer: licenseParamsSerializer,
  })
);
export const getCowbellAgentSurplusLineLicenses = (
  params: Record<string, unknown> = {}
) => getCowbellAgentSurplusLineLicensesHandler({ params });

const createAgencyLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/license',
  method: 'post',
});
export const createAgencyLicense = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => createAgencyLicenseHandler({ data });

const updateAgencyLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/license',
  method: 'put',
});
export const updateAgencyLicense = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => updateAgencyLicenseHandler({ data });

const deleteAgencyLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/license/:licenseId',
  method: 'delete',
});
export const deleteAgencyLicense = ({
  licenseId,
}: {
  licenseId: string | number;
}) => deleteAgencyLicenseHandler(licenseId);

const getAgentLicensesHandler = makeCancelable(
  ServiceHandler({
    url: '/api/agency/v1/agent/license/search',
    paramsSerializer: licenseParamsSerializer,
  })
);
export const getAgentLicenses = (params: Record<string, unknown> = {}) =>
  getAgentLicensesHandler({ params });

const createAgentLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/agent/license',
  method: 'post',
});
export const createAgentLicense = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => createAgentLicenseHandler({ data });

const updateAgentLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/agent/license',
  method: 'put',
});
export const updateAgentLicense = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => updateAgentLicenseHandler({ data });

const deleteAgentLicenseHandler = ServiceHandler({
  url: '/api/agency/v1/agent/license/:licenseId',
  method: 'delete',
});
export const deleteAgentLicense = ({
  licenseId,
}: {
  licenseId: string | number;
}) => deleteAgentLicenseHandler(licenseId);

const getStateNoticesHandler = ServiceHandler({
  url: '/api/docs/v1/template?type=surplusNotice&state=:state',
  method: 'get',
});
export const getStateNotices = ({ state }: { state: string }) =>
  getStateNoticesHandler(state);

const getAgentLicenseNumberHandler = ServiceHandler({
  url: '/api/agency/v1/agent/license/:state',
  method: 'get',
  paramsSerializer: licenseParamsSerializer,
});
export const getAgentLicenseNumber = (params: Record<string, unknown> = {}) => {
  const { state, ...query } = params as { state?: string | number };
  return getAgentLicenseNumberHandler(state as string | number, {
    params: query,
  });
};
